import { Pto } from '@outcoreaix/pto'
import { apiSlice } from './api-splice'

export const learnWorldsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getLearnWorldsLoginLink: builder.query<Pto.LearnWorlds.LoginLink, void>({
      query: () => ({
        url: `learn-worlds/login-link`,
        method: 'GET'
      })
    }),

    getCertificateStatus: builder.query<Pto.LearnWorlds.CertificateStatus, void>({
      query: () => ({
        url: `learn-worlds/certificate-status`,
        method: 'GET'
      })
    })
  })
})

export const { useLazyGetLearnWorldsLoginLinkQuery, useGetCertificateStatusQuery } = learnWorldsApi
